import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.firstAccess.pageTitle',
    defaultMessage: 'Modifica password',
    description: 'Title of the first access page',
  },
  pageSubtitle: {
    id: 'features.firstAccess.pageSubtitle',
    defaultMessage: 'Inserisci i dati corretti per modificare la password',
    description: 'Subtitle of the first access page',
  },
  oldPasswordLabel: {
    id: 'features.firstAccess.oldPasswordLabel',
    defaultMessage: 'Vecchia password / Codice provvisorio',
    description: 'Label shown above the old password input field',
  },
  oldPasswordPlaceholder: {
    id: 'features.firstAccess.oldPasswordPlaceholder',
    defaultMessage: 'Vecchia password / Codice provvisorio',
    description: 'Placeholder of the old password input field',
  },
  newPasswordLabel: {
    id: 'features.firstAccess.newPasswordLabel',
    defaultMessage: 'Nuova password',
    description: 'Label shown above the new password input field',
  },
  newPasswordPlaceholder: {
    id: 'features.firstAccess.newPasswordPlaceholder',
    defaultMessage: 'Nuova password',
    description: 'Placeholder of the new password input field',
  },
  confirmPasswordLabel: {
    id: 'features.firstAccess.confirmPasswordLabel',
    defaultMessage: 'Conferma nuova password',
    description: 'Label shown above the confirmation new password input field',
  },
  confirmPasswordPlaceholder: {
    id: 'features.firstAccess.confirmPasswordPlaceholder',
    defaultMessage: 'Conferma nuova password',
    description: 'Placeholder of the confirmation new password input field',
  },
  firstAccessButton: {
    id: 'features.firstAccess.firstAccessButton',
    defaultMessage: 'Conferma',
    description: 'Label of the first access button',
  },
  disclaimer: {
    id: 'features.firstAccess.disclaimer',
    defaultMessage: 'Torna alla ',
  },
  errorTitlePasswordAlreadyUsed: {
    id: 'features.firstAccess.errorTitlePasswordAlreadyUsed',
    defaultMessage:
      'La password non può coincidere con una password precedentemente inserita',
    description: 'Error message for password already used',
  },
  errorTitleInvalidCredentials: {
    id: 'features.firstAccess.errorTitleInvalidCredentials',
    defaultMessage: 'Password non corretta',
    description: 'Error message for password or username not valid',
  },
  errorTitleInvalidCriteria: {
    id: 'features.firstAccess.errorTitleInvalidCriteria',
    defaultMessage: 'La password non soddisfa i criteri :',
    description: 'Error title for password format not valid',
  },
  errorDescriptionInvalidCriteria: {
    id: 'features.firstAccess.errorDescriptionInvalidCriteria',
    defaultMessage:
      ' - Minimo 8 caratteri, \n - Non può contenere lo Username, \n - Deve contenere sia numeri che lettere, \n - Deve contenere almeno un carattere speciale o un carattere maiuscolo',
    description: 'Error description for password format not valid',
  },
  errorTitlePasswordNotMatching: {
    id: 'features.firstAccess.errorTitlePasswordNotMatching',
    defaultMessage:
      'La nuova password scelta non coincide con quella indicata nel campo Conferma nuova password',
    description: 'Error title for password not matching confirmation',
  },
  firstAccessCompletedAlertMessage: {
    id: 'features.firstAccess.firstAccessCompletedAlertMessage',
    defaultMessage:
      'Modifica password avvenuta con successo. Puoi effettuare il login con la nuova password.',
    description:
      'Message shown in the alert the confirms to the user that the first access operation has been completed successfully',
  },
  errorTitleFillInAllFields: {
    id: 'features.firstAccess.errorTitleFillInAllFields',
    defaultMessage: 'Compila tutti i campi',
    description: 'Error title fo fill in all fileds',
  },
});
